import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKoreacard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 16,
	viewBox: "0 0 24 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.77801 3.18679L3.67334 4.84567L3.84934 4.96175C3.9467 5.02916 4.07027 5.11154 4.12644 5.14524L4.22755 5.21265L5.33222 3.55376L6.4369 1.89488L6.2609 1.77879C6.16354 1.71139 6.03996 1.62901 5.98379 1.5953L5.88269 1.5279L4.77801 3.18679Z",
			fill: "#1D252B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7984 1.71496L17.5288 1.89471L18.0343 2.65487L18.5399 3.41504L18.641 3.34764C18.6971 3.31393 18.8207 3.23155 18.9181 3.16415L19.0941 3.04806L18.5923 2.29164C18.3114 1.87598 18.083 1.53522 18.0755 1.53522C18.0718 1.53522 17.9482 1.6176 17.7984 1.71496Z",
			fill: "#1D252B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.62469 3.73718C5.0218 4.6359 4.53125 5.38483 4.53125 5.39606C4.53125 5.42228 5.05925 5.77802 5.07423 5.7593C5.10793 5.7181 7.26485 2.46774 7.26485 2.46025C7.26485 2.44527 6.75183 2.09702 6.72937 2.09702C6.72188 2.09702 6.22384 2.83472 5.62469 3.73718Z",
			fill: "#1D252B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.971 2.26178C16.8437 2.35166 16.7276 2.43404 16.7164 2.44527C16.7014 2.45651 18.7834 5.62823 18.892 5.7593C18.907 5.77802 19.435 5.42228 19.435 5.39606C19.435 5.35862 17.2519 2.09702 17.2294 2.10076C17.2182 2.10076 17.1021 2.17566 16.971 2.26178Z",
			fill: "#1D252B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.44069 4.30634C5.8378 5.21254 5.35099 5.96148 5.35848 5.96896C5.36597 5.97645 5.48955 6.05884 5.63184 6.15245L5.89397 6.32471L6.99116 4.6808C7.59405 3.77459 8.08834 3.02566 8.08834 3.01443C8.08834 2.9957 7.66145 2.70362 7.5903 2.67366C7.5566 2.66243 7.1709 3.20915 6.44069 4.30634Z",
			fill: "#1D252B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.1283 2.82727C15.9898 2.92088 15.8774 3.00701 15.8774 3.0145C15.8774 3.02574 16.1021 3.37024 16.3755 3.78216L16.8735 4.52734L17.1356 4.35509C17.2779 4.26147 17.4015 4.17909 17.409 4.1716C17.4277 4.15288 16.4354 2.65876 16.4054 2.65876C16.3942 2.65876 16.2669 2.73365 16.1283 2.82727Z",
			fill: "#1D252B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.9967 3.51257L18.7271 3.69231L19.2326 4.45248L19.7381 5.21265L19.8392 5.14524C19.8954 5.11154 20.019 5.02916 20.1163 4.96175L20.2923 4.84567L19.7905 4.08925C19.5097 3.67359 19.2813 3.33283 19.2738 3.33283C19.27 3.33283 19.1465 3.41521 18.9967 3.51257Z",
			fill: "#1D252B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.3266 4.62463C17.188 4.71825 17.0757 4.80438 17.0757 4.81186C17.0757 4.8231 17.3004 5.16761 17.5737 5.57952L18.0718 6.32471L18.3339 6.15245C18.4762 6.05884 18.5998 5.97645 18.6072 5.96896C18.626 5.95024 17.6336 4.45612 17.6037 4.45612C17.5924 4.45612 17.4651 4.53101 17.3266 4.62463Z",
			fill: "#1D252B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.61671 9.83348C5.4819 9.92709 5.3733 10.0207 5.37705 10.0469C5.38079 10.0881 7.4441 13.2149 7.52648 13.3048C7.55644 13.3422 8.09567 12.9977 8.08069 12.9528C8.05448 12.8929 5.89755 9.66497 5.87883 9.66497C5.8676 9.66497 5.75151 9.73986 5.61671 9.83348Z",
			fill: "#1D252B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5809 10.3953C17.315 10.7997 17.0903 11.1442 17.0828 11.1554C17.0678 11.2004 17.6071 11.5449 17.637 11.5074C17.6857 11.455 18.5769 10.1069 18.5957 10.0582C18.6069 10.032 18.5058 9.9384 18.3523 9.8373C18.2062 9.73994 18.0826 9.6613 18.0789 9.6613C18.0714 9.6613 17.8505 9.99457 17.5809 10.3953Z",
			fill: "#1D252B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.78202 10.3953C4.61726 10.5039 4.53113 10.5825 4.54611 10.6162C4.56483 10.6649 5.44857 12.0092 5.501 12.0654C5.51972 12.0879 5.91665 11.852 6.05895 11.7396C6.07393 11.7246 5.08159 10.2268 5.05538 10.223C5.04415 10.223 4.92057 10.3017 4.78202 10.3953Z",
			fill: "#1D252B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.3937 10.9757C18.1204 11.3914 17.8994 11.7321 17.9069 11.7396C18.0492 11.852 18.4462 12.0879 18.4649 12.0654C18.5136 12.0092 19.401 10.6649 19.4198 10.6162C19.4385 10.5713 19.079 10.2904 18.9404 10.2417C18.9105 10.2305 18.697 10.5189 18.3937 10.9757Z",
			fill: "#1D252B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.92423 10.9607L3.67334 11.1292L4.78176 12.7881L5.89018 14.4507L6.16354 14.2635L6.44064 14.08L5.34346 12.4323C4.74431 11.5261 4.23504 10.7884 4.21257 10.7884C4.19385 10.7884 4.06278 10.867 3.92423 10.9607Z",
			fill: "#1D252B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.2212 11.5334L18.7231 12.2824L19.0002 12.4658L19.2774 12.6531L19.7829 11.8892L20.2922 11.129L20.03 10.9567C19.8877 10.8631 19.7604 10.7845 19.7454 10.7845C19.7267 10.7845 19.4908 11.1215 19.2212 11.5334Z",
			fill: "#1D252B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.3826 12.1926C16.1168 12.597 15.8921 12.9415 15.8846 12.9528C15.8696 12.9977 16.4088 13.3422 16.4388 13.3048C16.4875 13.2524 17.3787 11.9043 17.3974 11.8556C17.4087 11.8294 17.3076 11.7358 17.154 11.6347C17.008 11.5373 16.8844 11.4587 16.8807 11.4587C16.8732 11.4587 16.6522 11.7919 16.3826 12.1926Z",
			fill: "#1D252B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.98026 12.1926C5.8155 12.3012 5.72937 12.3799 5.74435 12.4136C5.76307 12.4623 6.64681 13.8066 6.69924 13.8628C6.71796 13.8852 7.11489 13.6493 7.25719 13.537C7.27217 13.522 6.27984 12.0241 6.25362 12.0204C6.24239 12.0204 6.11882 12.099 5.98026 12.1926Z",
			fill: "#1D252B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.1955 12.7731C16.9221 13.1887 16.7012 13.5295 16.7087 13.537C16.851 13.6493 17.2479 13.8852 17.2666 13.8628C17.3153 13.8066 18.2028 12.4623 18.2215 12.4136C18.2402 12.3686 17.8808 12.0878 17.7422 12.0391C17.7122 12.0279 17.4988 12.3162 17.1955 12.7731Z",
			fill: "#1D252B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.0229 13.331L17.5249 14.08L17.802 14.2635L18.0791 14.4507L18.5846 13.6868L19.0939 12.9266L18.8318 12.7544C18.6895 12.6607 18.5622 12.5821 18.5472 12.5821C18.5285 12.5821 18.2926 12.9191 18.0229 13.331Z",
			fill: "#1D252B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4741 4.19817C15.9736 4.69261 15.8959 7.99754 15.8959 7.99754C15.8959 7.99754 15.3256 6.62462 13.6406 6.72243C12.7618 6.77345 12.1375 7.1027 11.6965 7.86745C11.4113 8.36185 9.98563 9.42881 8.74137 7.86745C7.71643 6.58129 9.52891 3.78204 12.4741 4.19817Z",
			fill: "#E31124"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.6059 11.8173C8.00859 11.3115 8.08852 7.93061 8.08852 7.93061C8.08852 7.93061 8.67477 9.3351 10.4068 9.23503C11.3102 9.18285 11.952 8.84603 12.4054 8.0637C12.6985 7.55792 14.1641 6.46644 15.4431 8.0637C16.4967 9.37942 14.6336 12.243 11.6059 11.8173Z",
			fill: "#394C9B"
		})
	]
});
export default SvgKoreacard;
